import {
  convertSerializableEntryInfo,
  SerializableInspectionMediaEntry
} from '../../models/SerializableSdkTypes/SerializableDviTypes'
import { InspectionMediaEntry } from '../../sdk'
import { ReplicacheInstance } from '..'

export async function deleteInspectionMedia(
  entry: InspectionMediaEntry,
  inspectionId: string,
  rep: ReplicacheInstance | undefined
) {
  if (!rep) {
    return
  }
  const updatedEntry: SerializableInspectionMediaEntry = {
    id: entry.id!,
    info: convertSerializableEntryInfo({ ...entry.info! }),
    mediaUrl: entry.mediaUrl || null,
    thumbnailUrl: entry.thumbnailUrl || null
  }
  await rep.mutate.deleteInspectionMedia({
    inspection: inspectionId,
    media: updatedEntry
  })
}
